import React, {Component, ReactNode} from 'react';

export default class Holder extends Component<{children?: React.ReactNode}> {
    render(): ReactNode {
        return <div className="article--preview__body">{this.props.children}</div>;
    }
}
